<template>
  <div 
    class="mt-8 mx-4">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat
            min-height="calc(100vh - 245px)">
            <v-card-text
              v-if="Object.keys(detail).length < 1" 
              class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <div class="mb-2 title">
                  Mohon Tunggu...
                </div>
                <v-progress-circular
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>

            <v-card-text v-if="Object.keys(detail).length > 0">
              <div>
              <div class="d-flex mb-3 mt-0">
                <div>
                  <div class="fs-16 font-weight-bold">
                    Detail Toko
                  </div>
                </div>
                <v-spacer />
                <div>
                  <!-- @click="dialog.form = true; reset();" -->
                  <!-- <v-btn
                    color="#1814F3"
                    width="195"
                    height="35"
                    elevation="0"
                    style="border-radius: 9px;"
                    :to="`/customer/toko/add/${detail.id}`"
                    class="fs-16 white--text text-capitalize">
                    <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                    Tambah Toko
                  </v-btn> -->
                </div>
              </div>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card
                    class="pa-0"
                    height="100%"
                    flat
                    style="border-radius: 15px;">

                    <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                      {{ detail.name }}
                    </v-card-text> -->

                    <v-card-text class="body-2 font-weight-light text-first pa-2 pt-0">
                      <!-- <p class="mb-2">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        <span v-if="item.start === item.end">
                          Tanggal <b>{{ item.date | date }}</b>
                        </span>
                      </p> -->

                      <!-- <p class="mb-2">
                        <v-icon small class="mr-2">mdi-account</v-icon>
                        <span>
                          <b>{{ detail.pic_name }}</b>
                        </span>
                      </p> -->

                      <!-- <p class="mb-2">
                        <v-icon small class="mr-2">mdi-map-marker</v-icon>
                        <span>
                          <b>{{ detail.address }}</b>
                        </span>
                      </p> -->
                      <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                          <table style="width: 100%;">
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                Nama Toko
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.name !== '' ? detail.name : '-'}}
                              </td>
                            </tr><tr>
                              <td style="width: 100px; min-width: 100px;">
                                Nama Customer
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.customer_name !== '' ? detail.customer_name : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                PIC
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.pic_name !== '' ? detail.pic_name : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                Tipe Toko
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.type !== '' ? detail.type : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 100px; min-width: 100px;">
                                Kode Outlet
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                <!-- {{ detail.code }} -->
                                  {{ detail.activation_code }}
                                <!-- <div class="d-flex" style="width: 100%;">
                                  <div style="width: 100%;">
                                    <v-text-field
                                      v-model="detail.code"
                                      outlined
                                      dense
                                      class="fs-14"
                                      style="width: 100%;"
                                    ></v-text-field>
                                  </div>
                                  <div class="ml-2">
                                    <v-btn
                                      color="#1814F3"
                                      width="100"
                                      height="50"
                                      :loading="process.form"
                                      :disabled="process.form"
                                      elevation="0"
                                      @click="save(item)"
                                      style="border-radius: 4px;"
                                      class="fs-16 white--text text-capitalize">
                                      Simpan
                                    </v-btn>
                                  </div>
                                </div> -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Alamat
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.village_name !== '' ? detail.village_name : '-'}}, {{ detail.subdistrict_name !== '' ? detail.subdistrict_name : '-'}}, {{ detail.city_name !== '' ? detail.city_name : '-'}} - {{ detail.province_name !== '' ? detail.province_name : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Detail Alamat
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.address_detail !== '' && detail.address_detail !== null ? detail.address_detail : '-'}}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Catatan
                              </td>
                              <td style="max-width: 30px; min-width: 30px; width: 30px;" class="text-center">
                                :
                              </td>
                              <td class="py-1 font_weight_600 black--text" style="width: 100%;">
                                {{ detail.notes !== '' ? detail.notes : '-'}}
                              </td>
                            </tr>
                          </table>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <div class="">
                            <div v-if="detail.latitude === ''">
                              -
                            </div>
                            <div v-if="detail.latitude !== ''">
                              <iframe 
                                width="100%" 
                                height="250" 
                                frameborder="0" 
                                scrolling="no" 
                                marginheight="0" 
                                marginwidth="0" 
                                language="id"
                                :src="`https://www.google.com/maps/embed/v1/place?key=AIzaSyCpSBm0ehBiEr4muaISG3Rgm_UNR6Bfd5M&q=${detail.latitude},${detail.longitude}&language=id`"
                                >
                              </iframe>
                            </div>
                            <!-- <div v-if="detail.latitude !== ''">
                              <gmap-map
                                :center="{
                                  lat: (detail.latitude)*1,
                                  lng: (detail.longitude)*1
                                }"
                                :zoom="16"
                                :options="{
                                  zoomControl: true,
                                  mapTypeControl: false,
                                  scaleControl: false,
                                  streetViewControl: false,
                                  rotateControl: false,
                                  fullscreenControl: true,
                                  disableDefaultUi: false
                                }"
                                style="width: 100%; height: 170px;">
      
                                <gmap-marker
                                  :position="{
                                    lat: (detail.latitude)*1,
                                    lng: (detail.longitude)*1
                                  }">
                                </gmap-marker>
                              </gmap-map>
                            </div> -->
                          </div>
                        </v-col>
                        <v-col cols="12" md="12" class="">
                          <div>
                            <div 
                              class="fs-14">
                              <!-- <span class="red--text">*</span> -->
                              Gambar 
                          </div>
                          <v-row>
                            <v-col 
                              v-for="(item, index) in detail.images"
                              :key="index"
                              cols="12"
                              md="4">
                              <v-card 
                                flat
                                width="100%"
                                height="220"
                                class="d-flex align-center justify-center"
                                style="border-radius: 15px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;
                                      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                                <v-img 
                                  alt="megavin" 
                                  width="100%"
                                  height="200"
                                  :src="item"
                                  contain
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
    
                                  <!-- <div 
                                    @click="form.images.splice(index, 1)"
                                    class="cursor-pointer"
                                    style="position: absolute; top: 5px; right: 5px;">
                                    <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                  </div> -->
                                </v-img>
                              </v-card>
                            </v-col>
                          </v-row>
    
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              
              
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        markers: [],
        detail: {},
      place: null,
        form: {
          id: '',
          customer_id: '',
          name: '',
          pic_name: '',
          address: '',
          latitude: '-2.9198476',
          longitude: '104.645729',
          images: [],
          notes: [],
          is_blokir: '0',
          province_name: '',
          city_name: '',
          subdistrict_name: '',
          village_name: '',
        },
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        customer: [],
        customer: [],
        menu: ['Koordinat', 'Polygon'],

        selected: {
          row: [],
          freeze: [],
          delete: [],

          menu: 'Koordinat'
        },

        map: null,

        center: {
          lat: -2.9198476, 
          lng: 104.645729
        },

        upload: {
          images: null
        },

        process: {
          form: false,

          file: false,
          load: false,
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              // this.upload.images.map(obj => {
                this.form.images.push(
                  this.upload.images.fileuri
                )
              // })

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/toko/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.form = res.results.data
            this.form.id = res.results.data.id
            this.form.images = res.results.data.images.length < 1 ? [] : JSON.parse(res.results.data.images)
            this.form.latitude = res.results.data.latitude
            this.form.longitude = res.results.data.longitude
            this.form.customer_id = res.results.data.customer_id
            this.form.name = res.results.data.name
            this.form.pic_name = res.results.data.pic_name
            this.form.address = res.results.data.address
            this.form.notes = res.results.data.notes
            this.form.is_blokir = res.results.data.is_blokir
            this.form.province_name = res.results.data.province_name
            this.form.city_name = res.results.data.city_name
            this.form.subdistrict_name = res.results.data.subdistrict_name
            this.form.village_name = res.results.data.village_name
            this.center = {
              lat: parseFloat(res.results.data.latitude),
              lng: parseFloat(res.results.data.longitude)
            }
            this.detail = res.results.data
            this.detail.images = res.results.data.images.length < 1 ? [] : JSON.parse(res.results.data.images)
            this.process.load = false

          }
          this.fetchCustomer()
          this.fetchProv()
          this.fetchProvEdit()
        })
      },
      async fetchProv() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      async fetchProvEdit() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
            if (this.form.province_name !== '') {
              if (this.province.length > 0) {
                this.province.map(obj => {
                  if (obj.name === this.form.province_name) {
                    this.fetchCityEdit(obj.id)
                  }
                })
              }
              
            }
          }
        })
      },

      async fetchCityEdit(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
            if (this.form.city_name !== '') {
              if (this.city.length > 0) {
                this.city.map(obj => {
                  if (obj.name === this.form.city_name) {
                    this.fetchSubEdit(obj.id)
                  }
                })
              }
            }
          }
        })
      },

      changeProvince() {
        this.form.city_name = ''
        this.form.subdistrict_name = ''
        this.form.village_name = ''
        let id = ''
        this.province.map(obj => {
          if (obj.name === this.form.province_name) {
            id = obj.id
          }
        })
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      async fetchSubEdit(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
            if (this.form.subdistrict_name !== '') {
              if (this.subdistrict.length > 0) {
                this.subdistrict.map(obj => {
                  if (obj.name === this.form.subdistrict_name) {
                    this.fetchVil(obj.id)
                  }
                })
              }
            }
          }
        })
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      changeCity() {
        this.form.subdistrict_name = ''
        this.form.village_name = ''
        let id = ''
        this.city.map(obj => {
          if (obj.name === this.form.city_name) {
            id = obj.id
          }
        })
        this.fetchSub(id)
      },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSub() {
        this.form.village_name = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.name === this.form.subdistrict_name) {
            id = obj.id
          }
        })
        this.fetchVil(id)
      },

      async fetchVil(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },
      setDescription(description) {
        this.description = description;
      },
      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
          this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },
      async fetchCustomer() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.customer = res.results.data
          }
        })
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -2.9198476, 
              lng: 104.645729
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form,
            images: JSON.stringify(this.form.images)
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/toko/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.message.success = res.message
              this.$router.go(-1)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>